import apiClient from 'services/api';

export const getBooking = (viewToken: string) =>
  apiClient.get<Kudable.BookingViewData>(`/public/bookings/${viewToken}`);

export const cancelBooking = (viewToken: string) =>
  apiClient.post<Kudable.BookingViewData>(
    `/public/bookings/${viewToken}/cancel`,
  );

export const acceptCounter = (viewToken: string) =>
  apiClient.post<Kudable.BookingViewData>(
    `/public/bookings/${viewToken}/accept-counter`,
  );

export const submitCompletionCode = (viewToken: string, code: string) =>
  apiClient.post<{ message: string }>(
    `/public/bookings/${viewToken}/complete`,
    { code },
  );
